module.exports = __webpack_public_path__ + "static/media/bounty_hunter.40a6852b.png";